/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_FailedInputs */

const en_us2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send it. Try again.`)
};

const pt_br2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tente de novo.`)
};

const es_419_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar. Inténtalo de nuevo.`)
};

const pt_pt2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tenta de novo.`)
};

const fr_fr2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi impossible. Réessaie.`)
};

const de_de2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden fehlgeschlagen. Versuch es erneut.`)
};

const it_it2_exercise_sheet_report_failed = /** @type {(inputs: Exercise_Sheet_Report_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio non riuscito. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't send it. Try again." |
*
* @param {Exercise_Sheet_Report_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_failed = /** @type {((inputs?: Exercise_Sheet_Report_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_failed(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_failed(inputs)
	return en_us2_exercise_sheet_report_failed(inputs)
});
export { exercise_sheet_report_failed as "exercise-sheet.report_failed" }